import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import { Card, Collapse } from "react-bootstrap";
import { getBikeHistoryFilters } from "actions/bike-history/actions";
import findFilterValue from "helpers/find-filter-value";
import FilterItem from "views/lib/components/filter/filter-item";
import FilterHeader from "views/lib/components/filter/filter-header";
import { getBikeStatuses } from "actions/bike/actions";

class Filers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      filters: {}
    };

    this.handleSearch = this.handleSearch.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleChangeFilter = this.handleChangeFilter.bind(this);

    this.props.getBikeStatuses();
    this.props.getBikeHistoryFilters();
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.totalCount !== this.props.totalCount) {
      return true;
    } else if (nextState.isOpen !== this.state.isOpen) {
      return true;
    } else if (!_.isEqual(nextState.filters, this.state.filters)) {
      return true;
    } else if (!_.isEqual(nextProps.activeFilters, this.props.activeFilters)) {
      return true;
    } else if (!_.isEqual(nextProps.serverFilters, this.props.serverFilters)) {
      return true;
    }
    return false;
  }

  handleSearch = () => {
    const { filters } = this.state;
    const filtersToArray = [];
    Object.keys(filters)
      .forEach(name => {
        if (Object.keys(filters[name]).length) {
          filtersToArray.push(filters[name]);
        }
      });
    this.props.handleSearch(filtersToArray);
  };

  handleReset = () => {
    this.setState({
      filters: {}
    }, this.props.handleReset);
  };

  handleChangeFilter = (name, valueObject) => {
    const { filters } = this.state;
    filters[name] = valueObject;
    this.setState({
      filters
    });
  };

  render() {
    const {
      activeFilters,
      totalCount,
      filters,
      bikeStatuses
    } = this.props;
    const {
      isOpen
    } = this.state;

    return (
      <Card className="w-100 mb-2 rounded-0">
        <FilterHeader
          title="Bikes History"
          totalCount={totalCount}
          isOpen={isOpen}
          onToggle={(status) => this.setState({ isOpen: status })}
        />
        <Card.Body className="p-0">
          <Collapse in={isOpen} className="p-3" timeout={0}>
            <div className="row">
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="bikeId"
                  placeholder="Bike ID"
                  filterType="text"
                  defaultValue=""
                  onChange={this.handleChangeFilter}
                  searchOperation={filters.bikeId || []}
                  value={findFilterValue("bikeId", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="bikeQr"
                  placeholder="QR"
                  filterType="text"
                  defaultValue=""
                  onChange={this.handleChangeFilter}
                  searchOperation={filters.bikeQr || []}
                  value={findFilterValue("bikeQr", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="username"
                  placeholder="Username"
                  filterType="text"
                  defaultValue=""
                  onChange={this.handleChangeFilter}
                  searchOperation={filters.username || []}
                  value={findFilterValue("username", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3"/>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="date"
                  placeholder="Date"
                  filterType="date"
                  onChange={this.handleChangeFilter}
                  searchOperation={filters.date || []}
                  value={findFilterValue("date", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="from"
                  placeholder="From"
                  filterType="select"
                  filterTypeOptions={bikeStatuses.map(value => ({
                    label: value,
                    value
                  }))}
                  onChange={this.handleChangeFilter}
                  searchOperation={filters.from || []}
                  value={findFilterValue("from", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="to"
                  placeholder="To"
                  filterType="select"
                  filterTypeOptions={bikeStatuses.map(value => ({
                    label: value,
                    value
                  }))}
                  onChange={this.handleChangeFilter}
                  searchOperation={filters.to || []}
                  value={findFilterValue("to", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <div className="d-flex justify-content-between justify-content-md-end">
                  <button
                    className="btn btn-warning btn-sm ml-2"
                    onClick={this.handleReset}
                  >
                    Reset
                  </button>
                  <button
                    className="btn btn-success btn-sm ml-2"
                    onClick={this.handleSearch}
                  >
                    Load
                  </button>
                </div>
              </div>
            </div>
          </Collapse>
        </Card.Body>
      </Card>
    );
  }
}

Filers.propTypes = {
  handleSearch: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
};

const mapStateToProps = state => ({
  filters: state.bikeHistory.filters,
  bikeStatuses: state.bike.statuses
});

const mapStateToDispatch = dispatch => ({
  getBikeHistoryFilters: bindActionCreators(getBikeHistoryFilters, dispatch),
  getBikeStatuses: bindActionCreators(getBikeStatuses, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(Filers);



// WEBPACK FOOTER //
// ./src/views/pages/bikes-history/filters.js